import _ from "lodash";

/**
 * Builds an array of options from the given data.
 *
 * @param {Array} data - The array of data objects to build options from.
 * @param {string} label - The key in each data object to use for the option label.
 * @param {string} value - The key in each data object to use for the option value.
 * @returns {Array} An array of option objects with `id`, `label`, and `value` properties.
 */
export const buildOptions = (data, label, value) => {
  return data.map((item, i) => {
    return {
      id: item["id"] ? item["id"] : item["@id"] ?? i,
      label: item[label] ?? item,
      value: item[value] ?? item,
    };
  });
};

/**
 * Builds an array of options from the given data.
 *
 * @param {Array} data - The array of data objects to build options from.
 * @param {string} label - The key in each data object to use for the option label.
 * @param {string} value - The key in each data object to use for the option value.
 * @returns {Array} An array of option objects with `id`, `label`, and `value` properties.
 */
export const buildOptionsAutoSelect = (data, label, value) => {
  return data.map((item, i) => {
    return {
      id: item["@id"] ? item["@id"] : item["id"] ?? i,
      label: i + " - " + item[label],
      value: item[value],
    };
  });
};

/**
 * Extracts the specified property from each object in the given array.
 *
 * @param {Object[]} obj - The array of objects to extract properties from.
 * @param {string} prop - The property name to extract from each object.
 * @returns {Array} An array containing the values of the specified property from each object.
 */
export const getEntityProperties = (obj, prop) => {
  if (_.isEmpty(obj)) return [];
  const r = [];
  obj.forEach((o) => {
    r.push(o[prop]);
  });

  return r;
};
